import { render, staticRenderFns } from "./DetailPanel.vue?vue&type=template&id=73b8020d"
import script from "./DetailPanel.vue?vue&type=script&lang=js"
export * from "./DetailPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports